// extracted by mini-css-extract-plugin
export default {"ordercard":"style_ordercard__hYcMw","productCard":"style_productCard__8Rikq","edit_form":"style_edit_form__IcJ37","buttons":"style_buttons__cr6Fb"};